<template>
  <div>
    <div class="userinfo">
      <div class="info_left">
        <div class="info_left_img">
          <img src="../../image/userimg.png" />
        </div>
      </div>
      <div class="information">
        <div class="infophone">{{ formInline.phone }}</div>
        <div class="infotheory">
          <div style="width: 160px;">
            会员状态:
            <span style="color:rgb(246,180,58)"> {{ formInline.status }}</span>
          </div>

          <div style="width: 260px;">
            开通时间:
            <span style="color:rgb(49,49,49)"> {{ formInline.timeOpen }}</span>
          </div>
          <div style="width: 178px;">
            到期期间:
            <span style="color:rgb(49,49,49)">
              {{ formInline.timeExpire }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="title">
      信息补充
    </div>
    <div class="titletwo">
      <div class="spwen">
        <el-form
          :inline="true"
          :rules="rules"
          :model="userInfo"
          class="demo-form-inline"
        >
          <el-form-item label="订单来源" class="itemlable">
            <el-input
              v-model="userInfo.source"
              placeholder="请输入订单来源"
            ></el-input>
          </el-form-item>
          <el-form-item label="订单金额" class="itemlable" prop="originalPrice">
            <el-input
              v-model="userInfo.originalPrice"
              placeholder="请输入订单金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="实付金额" class="itemlable" prop="originalPrice">
            <el-input
              v-model="userInfo.presentPrice"
              placeholder="请输入金额"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="itemimg">
      <div class="textcent">订单截图:</div>
      <div>
        <el-upload
          :limit="5"
          :headers="headers"
          :action="GLOBAL"
          list-type="picture-card"
          name="avatarfile"
          :on-success="vCoverPicSuccessFour"
          :on-preview="vCoverPicCardPreview"
          :on-remove="vCoverPicRemove"
          :before-upload="beforeAvatarUpload"
          :file-list="image"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>
    </div>
    <div class="title">
      审核结果
    </div>
    <div class="multiple">
      <el-form :inline="true" :model="userInfo" class="multipleradeo">
        <el-form-item label="是否通过：" class="itemlable">
          <el-radio v-model="userInfo.status" label="1">通过</el-radio>
          <el-radio v-model="userInfo.status" label="2">驳回</el-radio>
        </el-form-item>
        <el-form-item label="备     注:">
          <label slot="label"
            >备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注:</label
          >
          <el-input
            type="textarea"
            v-model="userInfo.remark"
            class="textareaa"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button type="info" size="medium">取消</el-button>
      <el-button type="warning" size="medium" @click="quechange"
        >确认</el-button
      >
    </div>
  </div>
</template>

<script>
import { getlistVip, getviplistApprove } from "../../api/index";
import premission from "../../utils/permission";
export default {
  mixins: [premission],
  data() {
    return {
      // 信息数据
      userInfo: {
        status: "1",
        source: "",
        originalPrice: "",
        presentPrice: "",
        remark: "",
        id: "",
        images: []
      },
      // 头部数据
      formInline: {
        phone: "",
        timetwo: "",
        status: 1,
        timeStart: "",
        timeEnd: "",
        timeExpireStart: "",
        timeExpireEnd: ""
      },
      rules: {
        originalPrice: [
          {
            pattern: "[0-9]",
            message: "请输入正确的金额",
            trigger: "blur"
          }
        ]
      },
      statusbarlist: {
        status: [
          { type: 0, name: "会员" },
          { type: 1, name: "已过期" }
        ]
      },
      headers: {
        Authorization: "Bearer " + window.sessionStorage.getItem("user_token")
      },
      image: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false
    };
  },

  created() {
    if (this.$route.params.id) {
      sessionStorage.setItem("themmeid", this.$route.params.id); //将params中的值存在本地，并且当他为空时不刷新
    }
    // 页面数据初始化
    this.themmephone();
  },
  // computed: {
  //   presentPrice: {
  //     get: function() {
  //       return this.userInfo.originalPrice * 0.96;
  //     },
  //     set: function(value) {
  //       this.userInfo.originalPrice = value / 0.96;
  //     }
  //   }
  // },

  // 监听订单价格变化
  watch: {
    "userInfo.originalPrice": {
      handler(newValue) {
        this.userInfo.presentPrice = (newValue * 0.96).toFixed(2);
      },

      deep: true
    }
  },
  methods: {
    // 返回状态码转中文
    tranfromType(info) {
      ["status"].forEach(key => {
        info[key] = this.statusbarlist[key]?.find(
          i => i.type === Number(info[key])
        )?.name;
      });
    },

    // 页面进来请求数据
    themmephone() {
      this.formInline.themmephone = sessionStorage.getItem("themmephone");
      let data = {
        phone: this.formInline.themmephone
      };
      getlistVip(data).then(res => {
        let data = res.data.data.list;
        data.forEach(info => {
          this.tranfromType(info);
        });
        this.formInline = data[0];
        console.log(this.formInline);
      });
    },
    // 图片上传成功时
    vCoverPicSuccessFour(response) {
      this.userInfo.images.push(response.msg);
    },
    // 图片删除
    vCoverPicRemove(file, fileList) {
      if (file.response !== undefined) {
        var index = this.userInfo.images.indexOf(file.response.msg);
      } else {
        var index = this.userInfo.images.indexOf(file.url);
      }

      if (index !== -1) {
        this.userInfo.images.splice(index, 1);
      }
    },
    // 图片预览
    vCoverPicCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 过滤非图片
    beforeAvatarUpload(file) {
      let types = [
        "image/jpeg",
        "image/jpg",
        "image/gif",
        "image/bmp",
        "image/png"
      ];
      const isImage = types.includes(file.type);
      const isLtSize = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error("上传图片只能是 JPG、JPEG、gif、bmp、PNG 格式!");
        return false;
      }
      if (!isLtSize) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      return true;
    },
    // 确认
    quechange() {
      this.userInfo.id = sessionStorage.getItem("themmeid");
      this.userInfo.presentPrice = (this.userInfo.originalPrice * 0.96).toFixed(
        2
      );
      let data = this.userInfo;
      console.log(data);
      getviplistApprove(data).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          this.$router.push({ path: "/toapplyTheList" });
        }
      });
      console.log(this.userInfo);
    }
  }
};
</script>
<style lang="less" scoped>
.userinfo {
  height: 180px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  .info_left {
    width: 226px;
    .info_left_img {
      overflow: hidden;
      border-radius: 50%;
      width: 150px;
      height: 150px;
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .information {
    width: 900px;
    height: 100%;
    .infophone {
      font-size: 28px;
      margin-top: 10px;
    }
    .infotheory {
      width: 706px;
      font-size: 14px;
      margin-top: 43px;
      font-weight: 550;
      color: rgb(196, 196, 196);
      letter-spacing: 2px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
}
.title {
  position: relative;
  width: 85%;
  height: 26px;
  line-height: 26px;
  font-size: 20px;
  text-indent: 15px;
}
.title::before {
  position: absolute;
  left: 0px;
  top: -3px;
  height: 36px;
  width: 6px;
  content: "";
  border-radius: 3px;
  background-color: #f6b439;
}
.titletwo {
  position: relative;
  width: 90%;
  height: 80px;
  font-size: 20px;
  text-indent: 15px;

  .spwen {
    margin-top: 20px;
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .demo-form-inline {
      width: 1050px;
      display: flex;
      justify-content: space-between;
      /deep/.el-form-item__label {
        font-size: 18px;
        color: black;
        padding: 0 0 0 0;
      }
      /deep/.el-input__inner {
        height: 32px;
      }
    }
  }
  // .itemimg {
  //   height: 150px;
  //   background-color: #f6b439;
  //   // display: flex;
  //   // flex-direction: row;
  //   // align-items: center;
  //   .textcent {
  //     width: 150px;
  //     height: 150px;
  //   }
  //   i.el-icon-plus {
  //     margin-left: -28px;
  //   }
  //   /deep/.el-upload-list__item-thumbnail {
  //     position: absolute;
  //     left: 0;
  //   }
  //   /deep/.el-dialog {
  //     // display: flex;
  //     // justify-content: center;
  //     img {
  //       width: 100%;
  //       margin-left: -15px;
  //     }
  //   }
  //   /deep/.el-upload-list--picture-card .el-upload-list__item {
  //     height: 146px;
  //     width: 146px;
  //     // margin-right: 20px;
  //   }
  //   .img_title {
  //     position: absolute;
  //     top: 24px;
  //     left: 30px;
  //     font-weight: bold;
  //     font-size: 20px;
  //     color: #000;
  //   }
  // }
}
.itemimg {
  height: 150px;
  margin: 20px 0 50px 0;
  // background-color: #f6b439;
  display: flex;
  flex-direction: row;
  align-items: center;
  .textcent {
    font-size: 18px;
    margin-right: 15px;
  }
}
.multiple {
  margin-top: 35px;
  width: 100%;
  display: flex;
  flex-direction: row;

  .multipleradeo {
    width: 550px;
    font-size: 18px;
    margin: 0 80px 0 15px;
    /deep/.el-form-item__label {
      font-size: 18px;
      margin-right: 25px;
      color: black;
    }
    /deep/.textareaa {
      width: 300px;
    }
  }
}
.footer {
  width: 309px;

  margin: 0px auto;
  display: flex;
  justify-content: space-between;
}
</style>
